/* Model */
class MongoHostModel extends App.Models.BaseModel {
    modelUrl = 'MongoHost';
}

App.Models.MongoHost = MongoHostModel;

/* Collection */
class MongoHostCollection extends App.Collections.BaseCollection {
    url = 'MongoHost';
    model = App.Models.MongoHost;
}

App.Collections.MongoHosts = MongoHostCollection;

/* Router */
class MongoHostRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'MongoHost';
        const model = App.Models.MongoHost;
        const collectionClass = App.Collections.MongoHosts;

        super(entityName, model, collectionClass);
    }
}

App.Routers.MongoHost = MongoHostRouter;
